export default "__VITE_ASSET__1956e8c3__"